import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { isNotNullOrEmpty } from "./utilities";

// Resolves an id (an explicit `id` prop wins over the route's :slug param),
// fetches the matching entity via `getById`, and stores the first result
// after applying `enrich`. Returns null until an entity has loaded, which
// callers use as their "not ready yet" render guard.
//
// `getById`/`enrich` are read at call time but deliberately left out of the
// effect's own dependency array: callers may pass fresh closures each render
// (e.g. to capture props), and re-running the fetch on every render would
// both defeat the point of the effect and, since `enrich` typically returns
// a new object, infinite-loop via its own setState. Refetching is instead
// driven by `resolvedId` plus whatever `extraDeps` a caller opts into.
export const useEntityById = (id, getById, enrich, extraDeps = []) => {
  const [entity, setEntity] = useState(null);
  const { slug } = useParams();
  const resolvedId = id ?? slug;

  useEffect(() => {
    const results = getById(resolvedId);
    if (isNotNullOrEmpty(results)) {
      setEntity(enrich(results[0]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedId, ...extraDeps]);

  return entity;
};
